<template>
    <div style="height: 100%">
        <div class="sa-flexbox" style="padding-bottom: 20px">
            <div class="sa-flexbox-header"></div>
            <div class="sa-flexbox-body">
                <div class="b-table-sticky-header">
                    <span class="sa-flexbox-body-title">Consensi</span>
                    <!--secondary btn-toolbar sa-margin-right float-sm-right-->
                    <b-button size="sm" variant="outline-success outline-primary-noborder sa-margin-right float-sm-right" @click="onClickAggiungiAccettazioneConsenso" class="mb-2">
                        <i class="fas fa-plus"></i>
                        Aggiungi
                    </b-button>
                    <b-table sticky-header ref="table" stacked="sm" striped hover :items="pazienteConsensiItems" :fields="pazienteConsensiFields" :current-page="1" :per-page="perPage" :key="listKey" sort-icon-left head-variant="light" class="sa-b-table">
                        <template #cell(index)="row">
                            {{ row.index + 1 }}
                        </template>

                        <template #cell(actions)="{ item }">
                            <b-container class="bv-example-row">
                                <b-button v-if="item.statoAttuale === 'FIRMATO' && item.tipologia == 'OBBLIGATORIO' && showReferta" tooltip.hover title="Referta" @click="onReferta()" size="sm" variant="outline-info">
                                    <i class="far fa-edit"></i>
                                </b-button>
                                <b-button v-if="checkConsensiFirmati(item)" size="sm" variant="outline-success" disabled>
                                    <font-awesome-icon icon="check"></font-awesome-icon>
                                </b-button>
                                <b-button v-else size="sm" variant="outline-danger" disabled>
                                    <font-awesome-icon icon="check"></font-awesome-icon>
                                </b-button>
                                <sign-print-button-component v-if="item.statoAttuale !== 'FIRMATO' && item.statoAttuale !== 'FIRMATO-CREATOREFERTO'" :jsonData="item" :tipo-firma="item.tipoFirma" @afterLoadDocument="onAfterLoadDocument(item, $event)"></sign-print-button-component>
                                <b-button v-if="item.statoAttuale !== 'FIRMATO' && item.statoAttuale !== 'FIRMATO-CREATOREFERTO'" v-b-tooltip.hover title="Cambia in Firmato" size="sm" class="no-text" variant="outline-secondary" @click="onFirma(item)">
                                    <i class="fas fa-signature"></i>
                                </b-button>
                                <print-component :documentRepository="true" :idRisorsa="item.id" :typeButton="'small'"> </print-component>
                                <!-- <b-button v-if="item.statoAttuale !== 'FIRMATO' && item.statoAttuale !== 'FIRMATO-CREATOREFERTO'" v-b-tooltip.hover title="Cancella consenso" size="sm" variant="outline-danger" class="mr-1 no-text" @click="onDeleteConsenso(item)">
                                    <font-awesome-icon icon="trash"></font-awesome-icon>
                                </b-button> -->
                            </b-container>
                        </template>
                    </b-table>
                </div>
            </div>
            <div class="sa-flexbox-footer" style="background-color: ciano">
                <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                    <b-col lg="3">
                        <p>{{ this.$i18n.t("patients.lblTotalRecords") }}: {{ rows }}</p>
                    </b-col>
                    <b-col lg="9">
                        <b-pagination v-model="currentPage" :total-rows="pazienteConsensiRows" :per-page="perPage" align="right" size="sm"></b-pagination>
                    </b-col>
                </b-row>
            </div>
        </div>
        <consensiList-modal-component ref="cmpConsensiListModalComponent"></consensiList-modal-component>
        <sign-print-component :tipo-firma="consensoSelezionato ? consensoSelezionato.tipoFirma : null" :utente="utentePerFirma" ref="cmpSignPrintComponent" @onshown="onShownCmpSignPrintComponent" @confermaSelezione="onConfermaSelezioneCmpSignPrintComponent" @afterSign="onAfterSignPrintComponent">
            <template slot="body-component">
                <consensi-list-component :selectable="true" ref="cmpConsensiListComponent" @rowSelected="onRowSelected"></consensi-list-component>
            </template>
        </sign-print-component>
    </div>
</template>

<script>
import axios from "axios";
import Vue from "vue";
import UtilityMixin from "../../../utility/UtilityMixin";
import PazienteConsensiMixin from "../mixins/PazienteConsensiMixin";
import PrintComponent from "../../../utility/components/PrintComponent.vue";
import ConsensiListModalComponent from "../../../consensi/components/ConsensiListModalComponent.vue";
import SignPrintComponent from "../../../utility/components/SignPrintComponent.vue";
import ConsensiListComponent from "../../../consensi/components/ConsensiListComponent.vue";
import SignPrintButtonComponent from "../../../utility/components/SignPrintButtonComponent.vue";
export default {
    mixins: [UtilityMixin, PazienteConsensiMixin],
    components: { PrintComponent, SignPrintComponent, ConsensiListComponent, ConsensiListModalComponent, SignPrintButtonComponent },
    data() {
        return {
            rows: 0,
            perPage: 50,
            currentPage: 1,
            idPaziente: null,
            codiceStruttura: null,
            sezione: null,
            documentoFirma: {},
            pathResource: "/pazienticonsensi",
            pathResourcePrintConsensi: "/pazienticonsensi/print",
            pathResourceConsensi: "/consensi",
            pathResourceConsensiDigitalSign: "/pazienticonsensi/digitalsign",
            pathResourcePazienti: "/pazienti",
            pathResourcePazienteEventi: "/pazienteeventi/lastevent",
            signedPdfViewer: null,
            listKey: 0,
            showReferta: false,
            jsonData: {},
            nomeFile: "Consenso_",
            descrizione: "Consenso",
            tipoDocumento: "Consenso",
            codiceApplicativo: "BOTOX-01",
            jsonPaziente: null,
            dataModel: null,
            consensoSelezionato: null,
        };
    },
    mounted() {
        // console.log(this.jsonAccettazione);
    },
    computed: {
        utentePerFirma() {
            let user = {};
            user = sessionStorage.getItem("user") ? JSON.parse(sessionStorage.getItem("user")) : {};

            return {
                ...user,
                id: user.id,
            };
        },
    },
    methods: {
        setDati(idPaziente, sezione) {
            let me = this;
            me.showReferta = UtilityMixin.methods.verificaPermessi(Vue.prototype.user, "pazienteeventibotox", 2);
            me.idPaziente = idPaziente;
            me.sezione = sezione;
            this.pazienteConsensiFiltro.page = me.currentPage;
            this.pazienteConsensiFiltro.forPage = me.perPage;
            this.pazienteConsensiFiltro.idPaziente = me.idPaziente;
            this.pazienteConsensiFiltro.sezione = me.sezione;
            me.loadData();
        },
        loadData() {
            this.loadDataResources(this.pathResourcePazienti + "/" + this.idPaziente, null, this.loadDataSuccess, null);
        },
        loadDataSuccess(response) {
            this.jsonData = response.data.data;
            this.pazienteConsensiLoadData();
        },
        checkConsensiFirmati(item) {
            return item.statoAttuale !== "FIRMATO" && item.statoAttuale !== "FIRMATO-CREATOREFERTO" ? false : true;
        },
        linkPrintData(item) {
            let me = this;
            let returnValue = me.pathResourcePrintConsensi + "/" + item.id;
            return returnValue;
        },
        onClickAggiungiAccettazioneConsenso() {
            this.pazienteConsensoNew();
            this.consensoSelezionato = null;
            if (this.jsonData.personaRiferimento !== null) {
                this.dataModel = {
                    nome: this.jsonData.nome,
                    cognome: this.jsonData.cognome,
                    comuneNascita: this.jsonData.comuneNascita,
                    dataNascita: this.formatDate(this.jsonData.dataNascita),
                    provinciaNascita: this.jsonData.provinciaNascita,
                    provinciaResidenza: this.jsonData.provinciaResidenza,
                    comuneResidenza: this.jsonData.comuneResidenza,
                    indirizzoResidenza: this.jsonData.indirizzoResidenza,
                    telefono: this.jsonData.telefono,
                    email: this.jsonData.email,
                    identificativo: this.jsonData.identificativo,
                    proprietario: Vue.prototype.user.lastname + " " + Vue.prototype.user.firstname,
                    personaRiferimento: this.jsonData.personaRiferimento === null ? "" : this.jsonData.personaRiferimento.anagraficaRiferimento.cognome + " " + this.jsonData.personaRiferimento.anagraficaRiferimento.nome,
                    personaRiferimentoIdentificativo: this.jsonData.personaRiferimento === null ? "" : this.jsonData.personaRiferimento.anagraficaRiferimento.identificativo,
                    personaRiferimentoLuogoNascita: this.jsonData.personaRiferimento === null ? "" : this.jsonData.personaRiferimento.anagraficaRiferimento.comuneNascita + " (" + this.jsonData.personaRiferimento.anagraficaRiferimento.provinciaNascita + ")",
                    personaRiferimentoDataNascita: this.jsonData.personaRiferimento === null ? "" : this.formatDate(this.jsonData.personaRiferimento.anagraficaRiferimento.dataNascita),
                    personaRiferimentoTelefono: this.jsonData.personaRiferimento === null ? "" : this.jsonData.personaRiferimento.anagraficaRiferimento.telefono,
                    personaRiferimentoEmail: this.jsonData.personaRiferimento === null ? "" : this.jsonData.personaRiferimento.anagraficaRiferimento.email,
                    personaRiferimentoRuolo: this.jsonData.personaRiferimento === null ? "" : this.jsonData.personaRiferimento.ruolo,
                };
            } else {
                this.dataModel = {
                    nome: this.jsonData.nome,
                    cognome: this.jsonData.cognome,
                    comuneNascita: this.jsonData.comuneNascita,
                    dataNascita: this.formatDate(this.jsonData.dataNascita),
                    provinciaNascita: this.jsonData.provinciaNascita,
                    provinciaResidenza: this.jsonData.provinciaResidenza,
                    comuneResidenza: this.jsonData.comuneResidenza,
                    indirizzoResidenza: this.jsonData.indirizzoResidenza,
                    telefono: this.jsonData.telefono,
                    email: this.jsonData.email,
                    identificativo: this.jsonData.identificativo,
                    proprietario: Vue.prototype.user.lastname + " " + Vue.prototype.user.firstname,
                    personaRiferimento: "",
                    personaRiferimentoIdentificativo: "",
                    personaRiferimentoLuogoNascita: "",
                    personaRiferimentoDataNascita: "",
                    personaRiferimentoTelefono: "",
                    personaRiferimentoEmail: "",
                    personaRiferimentoRuolo: "",
                };
            }
            this.$refs.cmpSignPrintComponent.init(); //creazione cosi pulisce la modale.
        },
        onClickFirmaConsenso(item) {
            let me = this;
            let link = process.env.VUE_APP_PATH_API + me.pathResourcePrintConsensi + "/" + item.nomeConsenso;
            axios
                .get(link)
                .then((response) => {
                    me.documentoFirma = item;
                    me.documentoFirma.base64 = response.data.data;
                    this.$emit("afterLoadData");
                })
                .catch(() => {
                    this.$emit("afterLoadData");
                });
        },
        onPrint() {
            console.log("Print");
        },
        onModifica() {
            console.log("Modifica");
        },
        onRowSelected(consenso) {
            this.consensoSelezionato = null;
            if (consenso) {
                this.consensoSelezionato = consenso;
                this.creaConsenso(consenso);
            } else {
                this.$refs.cmpSignPrintComponent.setData("Consenso Paziente", null);
            }
        },
        onShownCmpSignPrintComponent() {
            console.log(this.sezione);
            let idAmbulatorio = sessionStorage.getItem("idAmbulatorio");
            this.$refs.cmpConsensiListComponent.init({ sezione: this.sezione }, "/consensi/profiloambulatorio?idAmbulatorio=" + idAmbulatorio);
        },
        creaConsenso(consenso) {
            let item = {
                idConsenso: consenso.id,
                data: JSON.stringify(this.dataModel),
            };
            this.openShowModalLoading();
            axios
                .post(process.env.VUE_APP_PATH_API + this.pathResourceConsensi + "/create", item)
                .then((response) => {
                    this.closeShowModalLoading();
                    this.pdfViewer = "data:application/pdf;base64," + response.data.data;
                    this.$refs.cmpSignPrintComponent.setData(consenso.nomeConsenso, this.pdfViewer);
                })
                .catch((err) => {
                    this.closeShowModalLoading();
                    if (err.response.data) {
                        this.$bvToast.toast(err.response.data.messaggio, {
                            title: "Attenzione",
                            variant: "danger",
                            solid: true,
                        });
                    }
                    console.log(err);
                });
        },
        onConfermaSelezioneCmpSignPrintComponent(pdf) {
            //let sessionStorage = window.sessionStorage;
            //let idPrenotazione = sessionStorage.getItem("idPrenotazione");
            this.pazienteConsenso.idPaziente = this.jsonData.id;
            this.pazienteConsenso.idConsenso = this.consensoSelezionato.id;
            this.pazienteConsenso.nomeConsenso = this.consensoSelezionato.nomeConsenso;
            this.pazienteConsenso.pdfConsenso = pdf;
            this.pazienteConsenso.tipologia = this.consensoSelezionato.tipologia;
            //this.pazienteConsenso.idPrenotazione = idPrenotazione;
            this.saveResource(this.pathResource, this.pazienteConsenso, this.pazienteConsensoSaveSuccess, null);
        },
        pazienteConsensoSaveSuccess(response) {
            this.pazienteConsenso = response.data.data;
            this.setConsensiDigitalSignPath();
            this.$refs.cmpSignPrintComponent.initConsenso(this.pazienteConsenso);

            this.pazienteConsensiLoadData();
        },
        resetConsensoSelezionato() {
            this.consensoSelezionato = null;
        },
        resetPazienteConsenso() {
            this.pazienteConsenso = { idPaziente: null, idConsenso: null, nomeConsenso: null };
        },
        onFirma(item) {
            this.pazienteConsensoCambiaStato(item.id, "FIRMATO");
        },
        onDeleteConsenso(item) {
            let me = this;
            me.$bvModal
                .msgBoxConfirm("Sicuro di voler procedere alla cancellazione del consenso?", {
                    title: "Conferma eliminazione",
                    size: "md",
                    buttonSize: "sm",
                    okVariant: "danger",
                    okTitle: "Sì",
                    cancelTitle: "No",
                    footerClass: "p-2",
                    hideHeaderClose: false,
                    centered: true,
                })
                .then((confirmed) => {
                    if (confirmed) {
                        me.deleteResource(me.pathResource + "/" + item.id, me.deleteConsensoSuccess, me.deleteConsensoError);
                    }
                })
                .catch((error) => {
                    console.log("Conferma cancellazione annullata", error);
                });
        },
        deleteConsensoSuccess() {
            this.pazienteConsensiLoadData();
        },
        deleteConsensoError(error) {
            console.log("Errore nella cancellazione del consenso", error);
        },
        onReferta() {
            let me = this;
            let filtro = { idPaziente: me.jsonData.id, gruppo: "BOTOX", tipoEvento: "ANAMNESI BOTOX" };
            this.loadDataResources(this.pathResourcePazienteEventi, filtro, this.loadDataAnamnesiSuccess, this.loadDataAnamnesiError);
            //verificoconsensi
            // me.$router.push("/paziente/botox/visita/edit/-1?idPaziente=" + me.jsonData.id);
        },
        loadDataAnamnesiSuccess(response) {
            response;
            this.$router.push("/paziente/botox/visita/edit/-1?idPaziente=" + this.jsonData.id);
        },
        loadDataAnamnesiError(error) {
            error;
            this.$router.push("/paziente/botox/anamnesi/edit/-1?idPaziente=" + this.jsonData.id);
        },
        onAfterLoadDocument(item, data) {
            let me = this;
            let tipoFirma = item.tipoFirma || data.tipoFirma || data.tipoFirmaConsenso;
            me.consensoSelezionato = { ...item, tipoFirma: tipoFirma };
            me.setConsensiDigitalSignPath();
            if (me.consensoSelezionato.tipoFirma || !item.idConsenso) {
                me.$refs.cmpSignPrintComponent.setDataForSign(data);
                return;
            }

            axios
                .get(process.env.VUE_APP_PATH_API + me.pathResourceConsensi + "/" + item.idConsenso)
                .then((response) => {
                    me.consensoSelezionato = { ...item, tipoFirma: response.data.data.tipoFirma };
                    me.$refs.cmpSignPrintComponent.setDataForSign(data);
                })
                .catch(() => {
                    me.$refs.cmpSignPrintComponent.setDataForSign(data);
                });
        },
        onAfterSignPrintComponent() {
            this.pazienteConsensiLoadData();
        },
        setConsensiDigitalSignPath() {
            if (this.$refs.cmpSignPrintComponent) {
                this.$refs.cmpSignPrintComponent.pathDigitalSign = this.pathResourceConsensiDigitalSign;
            }
        },
    },
};
</script>

<style></style>
